import GTextField, { IGTextFieldProps } from "./GTextField";

export default function GNumberField(props:IGTextFieldProps) {
    const formatter = (val:string) => {
        const match = val.match(/(\-?)(\d*?)(\.\d*)/)
        if (match && val!=match[0]) {
            const [_,neg,whole,dec] = match
            return [neg,whole,dec].filter(v => !!v).join("")
        }
        return val
    }
    return <GTextField {...props} formatter={formatter}/>
}